import {t} from "../../lang";

export default function GameCard( props ) {
    const handleClick = () => {
        if (props.isAvailable === 0) {
            return;
        }
        if (props.onClick) {
            props.onClick();
        }
    };

    // Use modulo to repeat delay pattern every 12 cards, preventing long delays for newly loaded cards
    const animationDelay = props.index !== undefined ? (props.index % 12) * 0.03 : 0;

    return(
        <div 
            className="game-card" 
            onClick={handleClick}
            style={{ 
                animationDelay: `${animationDelay}s`,
                '--animation-delay': `${animationDelay}s`
            }}
        >
            <div className="game-tags">
                {props.recent === 1 && (
                    <div className="game-tag new">{t("menu.game_new")}</div>
                )}

                {props.recommended === 1 && (
                    <div className="game-tag favorite">{t("menu.favorite")}</div>
                )}
            </div>
            <img src={ props.image } alt="game-card" />
            {props.isAvailable === 0 && (
                <div className="maintenance-overlay">
                    <button
                        type="button"
                        className="maintenance-btn"
                    >
                        Under Maintenance
                    </button>
                </div>
            )}
            <span> { props.title } </span>
        </div>
    )
}